import React from 'react'

import { IconS24Tram24 } from '@is24/cosma-ui-icons'
import { DistanceToFieldType } from '../../../../../@types/types'
import GenericDistanceToField from './fields/GenericDistanceToField/GenericDistanceToField'
import withDistanceToFields from './fields/withDistanceToFields'
import { InsertionFlowPagesTypeWithDistanceToFields } from '../../../../../@types/props-types'
import { SCREEN_CONNECTIONS, SCREENS } from '../../../../../services/domain/wizardScreens'
import { ConnectionsScreenValidationResult } from '../../../../../@types/validation-types'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'
import { getPropertyValue } from '../../../../../utils/types-utils'

const screen = SCREENS[SCREEN_CONNECTIONS]

const Connections: React.FC<InsertionFlowPagesTypeWithDistanceToFields> = ({
  insertionData,
  validationMessages,
  distanceToFields,
  onChange,
  onNavigate,
}) => {
  return (
    <ScreenContainer containerId={screen.id} className='' onNavigate={onNavigate} screen={screen}>
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={'wizard.screen.connections.header'}
        headerIcon={<IconS24Tram24 />}
        screenName={screen.name}
      >
        {distanceToFields.map((distanceToField: DistanceToFieldType) => (
          <GenericDistanceToField
            key={distanceToField.id}
            fieldValue={getPropertyValue(insertionData, distanceToField.fieldName) as string}
            errors={validationMessages![distanceToField.fieldName as keyof ConnectionsScreenValidationResult] ?? []}
            id={distanceToField.id}
            maxLength={distanceToField.maxLength}
            screenId={screen.id}
            fieldName={distanceToField.fieldName}
            screenName={screen.name}
            label={distanceToField.label}
            requiresMargin={distanceToField.requiresMargin}
            onChange={(screenProperty, value) => onChange(screenProperty, value)}
          />
        ))}
      </ScreenLayout>
    </ScreenContainer>
  )
}

export default withDistanceToFields(Connections)
